const JoinConfigurator = ({ joins, onAddJoin, onRemoveJoin, onUpdateJoin }) => {
  const handleChange = (index, field, value) => {
    const updatedJoin = { ...joins[index], [field]: value };
    onUpdateJoin(index, updatedJoin);
  };

  return (
    <div>
      {joins.map((join, index) => (
        <div key={index}  style={{backgroundColor: '#80bdff' }}  className="form-row mb-2 border rounded border-info px-4 py-2">
          <select
            name={`${index}_sel`}
            className="form-control col"
            value={join.type}
            onChange={e => handleChange(index, 'type', e.target.value)}
          >
            <option value="INNER">INNER JOIN</option>
            <option value="LEFT">LEFT JOIN</option>
            <option value="RIGHT">RIGHT JOIN</option>
          </select>
        <div className="row d-flex justify-content-between gap-2 mt-2">
          <input
            name={`${index}_t1`}
            className="form-control col"
            placeholder="Table A.Column"
            value={join.from}
            onChange={e => handleChange(index, 'from', e.target.value)}
          />

          <input
            name={`${index}_t2`}
            className="form-control col"
            placeholder="Table B.Column"
            value={join.to}
            onChange={e => handleChange(index, 'to', e.target.value)}
          />

          <button
            className="btn btn-danger ml-2"
            onClick={() => onRemoveJoin(index)}
          >
            ×
          </button>
          </div>
        </div>
      ))}

      <button className="btn btn-secondary mt-2" onClick={onAddJoin}>
        + Add Join
      </button>
    </div>
  );
};

export default JoinConfigurator;
